import { FiUsers } from 'react-icons/fi';

/**
 * Función para obtener los datos del usuario desde localStorage
 */
const getUserFromStorage = () => {
  try {
    const usuario = localStorage.getItem('usuario');
    return usuario ? JSON.parse(usuario) : null;
  } catch (error) {
    console.error('Error obteniendo datos del usuario:', error);
    return null;
  }
};


export const getMenuItems = (userData = null) => {
  // Obtener datos del usuario desde localStorage si no se proporcionan
  const user = userData || getUserFromStorage();

  const isSuperAdmin = user?.rol === 'admin';


  console.log('Sera super admin ? :', isSuperAdmin);

  return [
    {
      path: `${import.meta.env.BASE_URL}dashboard`,
      icon: <i className="fe fe-airplay"></i>,
      type: "sub",
      Name: "",
      active: false,
      selected: false,
      badge: "",
      badgetxt: "",
      class: "",
      title: "Dashboard",
      children: [
        {
          path: `${import.meta.env.BASE_URL}dashboard/resumen`,
          title: "Resumen",
          type: "link",
          active: false,
          selected: false,
        },
        //Solo mostrar Speech Analytics para superadmins
        /*...(isSuperAdmin ? [{
          path: `${import.meta.env.BASE_URL}dashboard/speech-analytics`,
          title: "Speech Analytics",
          type: "link",
          active: false,
          selected: false,
        }] : []),*/
        //Solo mostrar Estadísticas Consumo para superadmins
        ...(isSuperAdmin ? [{
          path: `${import.meta.env.BASE_URL}dashboard/estadisticas-consumo`,
          title: "Estadísticas Consumo",
          type: "link",
          active: false,
          selected: false,
        }] : [])
      ],
    },
    // Solo mostrar Fine-Tunning si es super admin
    ...(isSuperAdmin ? [{
      path: `${import.meta.env.BASE_URL}fine-tunning`,
      icon: <i className="fe fe-sliders"></i>,
      type: "sub",
      Name: "",
      active: false,
      selected: false,
      badge: "",
      badgetxt: "",
      class: "",
      title: "Fine - Tunning",
      children: [
        {
          path: `${import.meta.env.BASE_URL}fine-tunning/informacion-negocio`,
          title: "Información del negocio",
          type: "link",
          active: false,
          selected: false,
        },
        //  {
        //    path: `${import.meta.env.BASE_URL}fine-tunning/tiendas`,
        //    title: "Tiendas",
        //    type: "link",
        //    active: false,
        //    selected: false,
        //  },
        {
          path: `${import.meta.env.BASE_URL}fine-tunning/preguntas-frecuentes`,
          title: "Respuestas frecuentes",
          type: "link",
          active: false,
          selected: false,
        },
        //  {
        //    path: `${import.meta.env.BASE_URL}fine-tunning/productos`,
        //    title: "Productos",
        //    type: "link",
        //    active: false,
        //    selected: false,
        //  },
        //  {
        //    path: `${import.meta.env.BASE_URL}fine-tunning/medios`,
        //    title: "Medios",
        //    type: "link",
        //    active: false,
        //    selected: false,
        //  }
      ],
    }] : []),

    // Solo mostrar Bots si es super admin
    ...(isSuperAdmin ? [{
      path: `${import.meta.env.BASE_URL}bots`,
      icon: <i className="fe fe-cpu"></i>,
      type: "link",
      selected: false,
      active: false,
      title: "Bots",
    }] : []),
    //  {
    //    path: `${import.meta.env.BASE_URL}asistente-ia`,
    //    icon: <i className="ri-bard-line"></i>,
    //    type: "sub",
    //    Name: "",
    //    active: false,
    //    selected: false,
    //    badge: "",
    //    badgetxt: "",
    //    class: "",
    //    title: "Asistente IA",
    //    children: [
    //      {
    //        path: `${import.meta.env.BASE_URL}asistente-ia/asistente`,
    //        title: "Asistente IA",
    //        type: "link",
    //        active: false,
    //        selected: false,
    //      }
    //    ],
    //  },
    // Solo mostrar Automatización para administradores
    ...(isSuperAdmin ? [{
      path: `${import.meta.env.BASE_URL}automatizacion`,
      icon: <i className="fe fe-settings"></i>,
      type: "sub",
      Name: "",
      active: false,
      selected: false,
      badge: "",
      badgetxt: "",
      class: "",
      title: "Automatización",
      children: [
        {
          path: `${import.meta.env.BASE_URL}automatizacion/campaigns`,
          title: "Campañas",
          type: "link",
          active: false,
          selected: false,
        },
        /* {
          path: `${import.meta.env.BASE_URL}automatizacion/gestor-citas`,
          title: "Gestor de Citas",
          type: "link",
          active: false,
          selected: false,
        },
        {
          path: `${import.meta.env.BASE_URL}automatizacion/mensajes-recuperacion`,
          title: "Mensajes de recuperación",
          type: "link",
          active: false,
          selected: false,
        }, */
      ],
    }] : []),
    {
      path: `${import.meta.env.BASE_URL}base-datos`,
      icon: <i className="fe fe-database"></i>,
      type: "link",
      selected: false,
      active: false,
      title: "Base de datos",
    },
    {
      path: `${import.meta.env.BASE_URL}bandeja-mensajes`,
      icon: <i className="fe fe-mail"></i>,
      type: "sub",
      Name: "",
      active: false,
      selected: false,
      badge: "",
      badgetxt: "",
      class: "",
      title: "Bandeja de mensajes",
      children: [
        // {
        //   path: `${import.meta.env.BASE_URL}bandeja-mensajes/qr`,
        //   title: "Escaneo de QR",
        //   type: "link",
        //   active: false,
        //   selected: false,
        // },
        {
          path: `${import.meta.env.BASE_URL}bandeja-mensajes/conversaciones`,
          title: "Conversaciones",
          type: "link",
          active: false,
          selected: false,
        }
      ],
    },

    ...(isSuperAdmin ? [
      {
        path: `${import.meta.env.BASE_URL}configuracion/vendedores`,
        title: "Configuración",
        type: "link",
        icon: <i className="fe fe-settings"></i>,
        active: false,
        selected: false
      }
    ] : []),
  ];
};

// Mantenemos la exportación original para compatibilidad con versiones anteriores
export const MenuItems = getMenuItems();
